export default __webpack_public_path__ + "static/media/Group9268.5224edbe.svg";